<template>
  <div>
    <q-dialog :visible.sync="isVisible" title="新增申请" width="500px" :innerScroll="false" @close="onCancel">
      <div class="reject-content">
        <div v-if="boolSpecial" class="addText">此处可支持修改正在“控价中”的商品直播价</div>
        <el-form ref="rejectForm" :model="formData" :rules="rules" size="mini" label-width="110px">
          <el-form-item label="商品编码：" prop="goodsCode">
            <el-input v-model="formData.goodsCode" placeholder="请输入商品编码" maxlength="50"></el-input>
          </el-form-item>

          <el-form-item label="直播价：" prop="livePrice">
            <el-input-number v-model="formData.livePrice" placeholder="请输入直播价" :controls="false" :min="1" :precision="0"></el-input-number>
          </el-form-item>
          <el-form-item label="直播佣金：" prop="liveRebate">
            <el-select v-model="formData.liveRebate" placeholder="10%">
              <el-option label="10%" value="0.1"></el-option>
              <el-option label="15%" value="0.15"></el-option>
              <el-option label="20%" value="0.2"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="达人名称：" prop="authorName">
            <el-input v-model="formData.authorName" placeholder="请输入达人名称" maxlength="50"></el-input>
          </el-form-item>
          <el-form-item label="直播时间：" prop="liveDate">
            <el-date-picker
              v-model="formData.liveDate"
              type="date"
              placeholder="请选择直播时间"
              format="yyyyMMdd"
              value-format="yyyyMMdd"
            ></el-date-picker>
          </el-form-item>
        </el-form>
      </div>
      <template v-slot:footer>
        <div class="dialog-footer">
          <el-button @click="onCancel">取消</el-button>
          <el-button type="primary" @click="onSubmit" :loading="submitting">提交</el-button>
        </div>
      </template>
    </q-dialog>
    <prompt-dialog :visible.sync="promptVisible" :taskId="taskId" v-if="promptVisible" @success="successInit" />
  </div>
</template>

<script>
import promptDialog from './prompt-dialog';
export default {
  name: 'NewApplicationDialog',
  components: { promptDialog },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    boolSpecial: {
      type: Number,
      default: 0,
    },
    rowData: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    // 通过计算属性，对.sync进行转换，外部也可以直接使用visible.sync
    isVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit('update:visible', val);
      },
    },
  },
  data() {
    return {
      submitting: false,
      promptVisible: false,
      taskId: '',
      formData: {
        goodsCode: '',
        livePrice: undefined,
        liveRebate: '0.1',
        authorName: '',
        liveDate: '',
      },
      rules: {
        goodsCode: [{ required: true, message: '请输入商品编码', trigger: 'blur' }],
        livePrice: [{ required: true, message: '请输入直播价', trigger: 'blur' }],
        liveRebate: [{ required: true, message: '请选择直播佣金', trigger: 'change' }],
        authorName: [{ required: true, message: '请输入达人名称', trigger: 'blur' }],
        liveDate: [{ required: true, message: '请选择直播时间', trigger: 'blur' }],
      },
    };
  },
  methods: {
    onCancel() {
      this.isVisible = false;
    },

    onSubmit() {
      this.$refs.rejectForm.validate(valid => {
        if (!valid) return;
        this.submitting = true;
        let data = {
          ...this.formData,
          boolSpecial: this.boolSpecial,
        };
        this.$q.goods
          .goodsLivePriceAdd({ data: data })
          .then(res => {
            if(res.data && res.data.list && !this.boolSpecial) {
              this.promptVisible = true;
              this.taskId = res.data.list[0].taskId;
            } else {
              this.$message.success('提交成功');
              this.successInit();
            }
          })
          .finally(() => {
            this.submitting = false;
          });
      });
    },

    successInit() {
      this.$emit('success');
      this.isVisible = false;
    },
  },
};
</script>

<style lang="stylus" scoped>
.reject-content {
  >>> .el-date-editor.el-input__inner, >>> .el-select, >>> .el-input, >>> .el-input-number {
    width: 100% !important;
  }
}

.addText {
  color: red;
  margin: 15px 0;
  padding-left: 27px
}

.dialog-footer {
  text-align: center;
  padding-top: 10px;
}
</style>
